import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { updateContractor } from "sr/utils/api/company/workorder/updateContractor";
import { updateContractorDecline } from "sr/utils/api/company/workorder/updateContractorDecline";

export const DeclineContractor = () => {
  const [id, setId] = useState<string>("");
  const params = useParams();
  const [rejected, setRejected] = useState(false);
  const [loader, setLoader] = useState(true);
  useEffect(() => {
    const { id } = params;
    setId(id);
  }, [params]);

  useEffect(() => {
    const updateContractors = async (id) => {
      const payload = {
        id: id,
        status: "rejected",
      };
      const contractorres = await updateContractorDecline(payload);
      if (contractorres?.success === true) {
        setRejected(true);
        setLoader(false);
      }
    };
    if (id) {
      updateContractors(id);
    }
  }, [id]);

  return (
    <main>
      <ContentWithSpinner loader={loader} height="h-screen">
        <div className="lg:container mx-auto lg:max-w-3xl lg:mt-24 mt-8 px-4 lg:px-0">
          {rejected && (
            <div className="lg:flex block">
              <div className="lg:flex-1 lg:flex block w-full flex-col h-fit lg:mx-12 mx-auto lg:p-6  px-4 py-4 bg-white border border-gray-border rounded-xl">
                <p>You have successfully declined this invitation </p>
              </div>
            </div>
          )}
        </div>
      </ContentWithSpinner>
    </main>
  );
};
